import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export function useDeletePlan() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (planId: string) => {
      const { error } = await supabase
        .from("plans")
        .update({ is_active: false })
        .eq("id", planId);

      if (error) throw error;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["system-plans"] });
      queryClient.invalidateQueries({ queryKey: ["all-system-plans"] });
      queryClient.invalidateQueries({ queryKey: ["all-system-plans-with-bundles"] });
      toast.success("Plano arquivado com sucesso");
    },
    onError: (error: Error) => {
      console.error("Error archiving plan:", error);
      toast.error("Erro ao arquivar plano");
    },
  });
}
